export default __webpack_public_path__ + "static/media/send_mass_mail_hotels.cfaa34dd.png";